// Auto-generated by splitter.py — do not regenerate; edit directly.

import React, { useState, useEffect } from 'react';
import { AlertTriangle, CheckCircle2, Info, X, XCircle } from 'lucide-react';
import { TOAST_BUS } from '../lib/buses';

export const ToastContainer = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const handler = (t) => {
      setItems(prev => [...prev, t]);
      // An actionable toast waits for the operator — 4.2s expires before they reach the button.
      if (!t.action) setTimeout(() => setItems(prev => prev.filter(x => x.id !== t.id)), 4200);
    };
    TOAST_BUS.listeners.push(handler);
    return () => { TOAST_BUS.listeners = TOAST_BUS.listeners.filter(l => l !== handler); };
  }, []);
  if (items.length === 0) return null;
  return (
    <div className="fixed bottom-5 right-5 z-[100] flex flex-col gap-2 pointer-events-none">
      {items.map(t => {
        const cfg = t.kind === 'error' ? { bg: 'bg-[#9B1F1F]', icon: XCircle }
                  : t.kind === 'warning' ? { bg: 'bg-[#8A5A12]', icon: AlertTriangle }
                  : t.kind === 'info' ? { bg: 'bg-[#1E40AF]', icon: Info }
                  : { bg: 'bg-[#1F2937]', icon: CheckCircle2 };
        const Icon = cfg.icon;
        const dismiss = () => setItems(prev => prev.filter(x => x.id !== t.id));
        return (
          <div key={t.id} className={`${cfg.bg} text-white rounded-md shadow-lg px-3.5 py-2.5 min-w-[280px] max-w-[420px] pointer-events-auto flex items-start gap-2.5`}>
            <Icon className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={2} />
            <div className="flex-1 min-w-0">
              <div className="text-[12.5px] font-medium leading-tight">{t.message}</div>
              {t.detail && <div className="text-[11px] text-white/70 mt-1 leading-relaxed">{t.detail}</div>}
              {t.action && (
                <button
                  onClick={() => { dismiss(); t.action.onClick?.(); }}
                  className="mt-2 h-7 px-2.5 rounded bg-white/15 hover:bg-white/25 text-[11.5px] font-medium"
                >
                  {t.action.label}
                </button>
              )}
            </div>
            {t.action && (
              <button onClick={dismiss} aria-label="Dismiss" className="text-white/50 hover:text-white flex-shrink-0">
                <X className="w-3.5 h-3.5" strokeWidth={2} />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

// Modal — generic overlay used by confirm flows and wizards
